<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: ["open"],
        name: "AccordionContent",
        computed: {
            classes(){
                return `accordion__content${ this.open ? ' accordion__content--active' : ''}`;
            }
        }
    }
</script>